var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoExpirationDate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock_3_",
    "data-name": "clock (3)",
    transform: "translate(-1.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26411",
    "data-name": "Group 26411",
    transform: "translate(1.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26410",
    "data-name": "Group 26410",
    fill: "#00a1af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46754",
    "data-name": "Path 46754",
    d: "M6.2,1.215,5.169,0,1.493,3.063,2.521,4.278Z",
    transform: "translate(-1.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46755",
    "data-name": "Path 46755",
    d: "M307.424,3.17,303.748.107,302.72,1.322,306.4,4.385Z",
    transform: "translate(-291.424 -.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46756",
    "data-name": "Path 46756",
    d: "M30.023,45.653a7.15,7.15,0,1,0,7.2,7.15A7.17,7.17,0,0,0,30.023,45.653Zm0,12.711a5.561,5.561,0,1,1,5.6-5.561A5.582,5.582,0,0,1,30.027,58.364Z",
    transform: "translate(-22.027 -43.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46757",
    "data-name": "Path 46757",
    d: "M194.693,130.987h-1.2v4.767l3.8,2.268.6-.981-3.2-1.883Z",
    transform: "translate(-186.293 -126.109)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoExpirationDate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_expiration_date.32cdd02cdf2858a287b2470d878cbb64.svg";